'use strict';
import React from 'react';
import flux from 'utils/flux';
import t from 'tcomb-form';
import email from 'email-validation';
import Select from 'react-select';
import classnames from 'classnames';

var Form = t.form.Form;
var AccountEditPage = React.createClass({
    displayName: 'AccountEditPage',
    propTypes: {},
    getInitialState() {
        return {
            editMode: false,
            accountData: {}
        };
    },
    componentWillMount() {
        flux.getStore('app').loadAccountData();
    },
    componentWillReceiveProps(nextProps) {
        this.setState({accountData: nextProps.appStore.accountData});
    },
    saveAccountChanges(e) {
        e.preventDefault();
        var accountData = this.refs.form.getValue();
        if (accountData) {
            flux.getStore('app').updateAccountData(accountData).then(() => {
                this.setState({editMode: false});
            });
        }
    },
    chancelEditMode(e) {
        e.preventDefault();
        this.setState({editMode: false, accountData: this.props.appStore.accountData});
    },
    setEditMode(e) {
        e.preventDefault();
        this.setState({editMode: true});
    },
    onChange(value) {
        this.setState({accountData: value});
    },
    renderError() {
        if (this.props.appStore.error) {
            return <div className="field__error">{this.props.appStore.error}</div>;
        }
    },
    renderButtons() {
        var btnRow;
        if (this.state.editMode) {
            btnRow = (
                <div>
                    <button onClick={this.chancelEditMode} className="btn btn-secondary" type="button">
                        {flux.t('cancel')}
                    </button>
                    <button className="btn btn-primary btn-arrow" type="submit">
                        {flux.t('account_save')}
                        <i className="gopro-chevron-right" />
                    </button>
                </div>
            );
        } else {
            btnRow = (
                <button onClick={this.setEditMode} className="btn btn-primary btn-arrow" type="button">
                    {flux.t('account_edit')}
                    <i className="gopro-chevron-right" />
                </button>
            );
        }

        return btnRow;
    },
    render() {

        var AccountEdit = t.struct({
            firstName: t.Str,
            lastName: t.Str,
            email: t.subtype(t.Str, (s) => email.valid(s)),
            phoneNumber: t.Str,
            title: t.Str,
            company: t.Str,
            city: t.Str,
            zip: t.Str,
            state: t.Str,
            country: t.Str
        });

        var countryOptions = window.countryList.map((c) => {
            return {
                value: c.value,
                label: c.name
            };
        });

        var stateOptions = window.stateList.map((state) => {
            return {
                value: state,
                label: state
            };
        });

        var options = {
            auto: 'labels',
            template: function(locals) {
                var inputs = locals.inputs;
                return (
                    <div className="form__edit">
                        <div className="edit__left">
                            {inputs.firstName}
                            {inputs.lastName}
                            {inputs.email}
                            {inputs.phoneNumber}
                            {inputs.title}

                        </div>
                        <div className="edit__right">
                            {inputs.company}
                            {inputs.country}
                            {inputs.city}
                            <div className="edit__state">
                                {inputs.zip}
                                {inputs.state}
                            </div>
                        </div>
                    </div>);
            },
            fields: {
                firstName: {
                    error: flux.t('validation_firstName'),
                    label: flux.t('register_firstname'),
                    disabled: !this.state.editMode
                },
                lastName: {
                    error: flux.t('validation_lastName'),
                    label: flux.t('register_lastname'),
                    disabled: !this.state.editMode
                },
                email: {
                    error: flux.t('validation_email'),
                    label: flux.t('register_email'),
                    disabled: !this.state.editMode
                },
                phoneNumber: {
                    error: flux.t('validation_phoneNumber'),
                    label: flux.t('register_phone'),
                    disabled: !this.state.editMode
                },
                title: {
                    error: flux.t('validation_title'),
                    label: flux.t('register_title'),
                    disabled: !this.state.editMode
                },
                company: {
                    error: flux.t('validation_company'),
                    label: flux.t('register_company'),
                    disabled: !this.state.editMode
                },
                city: {
                    error: flux.t('validation_city'),
                    label: flux.t('register_city'),
                    disabled: !this.state.editMode
                },
                zip: {
                    error: flux.t('validation_postcode'),
                    label: flux.t('register_postcode'),
                    disabled: !this.state.editMode
                },
                state: {
                    error: flux.t('validation_state'),
                    label: flux.t('register_state'),
                    disabled: !this.state.editMode,
                    template: (locals) => {
                        var stateInput;
                        var countryCode = this.state.accountData.country;
                        if (locals.disabled || !countryCode || countryCode === '') {
                            var value = locals.value ? locals.value : flux.t('validation_country');
                            stateInput = (
                                <input type="text"
                                    value={value}
                                    disabled={locals.disabled} />);

                        } else if (countryCode !== 'US') {
                            var onChange = function(e) {
                                e.preventDefault();
                                locals.onChange(e.target.value);
                            };
                            stateInput = (
                                <input type="text"
                                    onChange={onChange}
                                    disabled={locals.disabled}
                                    value={locals.value} />);
                        } else if (countryCode === 'US') {
                            stateInput = (<Select
                                name="state"
                                options={stateOptions}
                                value={locals.value}
                                onChange={locals.onChange}
                            />);
                        }

                        return (
                            <div className="field">
                                <label>{locals.label}</label>
                                {stateInput}
                                {locals.hasError ? <div className="field__error">{locals.error}</div> : ''}
                            </div>);
                    }
                },
                country: {
                    error: flux.t('validation_country'),
                    label: flux.t('register_country'),
                    disabled: !this.state.editMode,
                    template: function(locals) {
                        if (locals.disabled) {
                            var value = locals.value;
                            var listValue = countryOptions.filter((_value) => _value.value === value);
                            if (listValue.length === 1) {
                                value = listValue[0].label;
                            }
                            return (
                                <div className="field">
                                    <label>{locals.label}</label>
                                    <input type="text" value={value} disabled={true} />
                                </div>
                            );
                        }
                        return (
                            <div className="field">
                                <label>{locals.label}</label>
                                <Select
                                    name="country"
                                    placeholder={flux.t('validation_country')}
                                    options={countryOptions}
                                    value={locals.value}
                                    onChange={locals.onChange}
                                />
                                {locals.hasError ? <div className="field__error">{locals.error}</div> : ''}
                            </div>
                        );
                    }
                }
            }
        };

        return (
            <div className="account__edit">
                <h4>{flux.t('account_details')}</h4>
                <form onSubmit={this.saveAccountChanges} className={classnames({'readonly': !this.state.editMode})}>
                    <Form
                      ref="form"
                      type={AccountEdit}
                      value={this.state.accountData}
                      onChange={this.onChange}
                      options={options}
                    />
                    <hr className="white" />
                    {this.renderError()}
                    <div className="edit__buttons">
                        {this.renderButtons()}
                    </div>
                </form>
            </div>);
    }
});

module.exports = AccountEditPage;



// WEBPACK FOOTER //
// ./app/pages/account/accountEdit.jsx